export default function () {
    let megaMenuContainers = jQuery('.js-mega-menu--container');
    let megaMenuClasses = [];

    megaMenuContainers.toArray().forEach((container) => {
        megaMenuClasses.push(String(jQuery(container).data('mega-menu-id')));
    });

    jQuery('.js-mega-menu--toggle').hover(function (event) {
        let megaMenuItem = jQuery(this);

        if (!megaMenuItem.hasClass('active')) {
            jQuery('.js-mega-menu--container').hide();
            jQuery('.js-mega-menu--toggle').removeClass('active');
            jQuery(megaMenuItem).addClass('active');

            let megaMenuFound = false;

            megaMenuClasses.forEach((megaMenuClass) => {
                if (jQuery(megaMenuItem).hasClass(megaMenuClass)) {
                    jQuery(`.js-mega-menu--container[data-mega-menu-id="${megaMenuClass}"]`).show();
                    megaMenuFound = true;
                }
            });

            if (megaMenuFound) {
                jQuery('header').addClass('mega-menu-opened');
            }
        }
    });

    jQuery('.js-mega-menu--submenu-item-trigger').hover(
        function () {
            jQuery('.js-mega-menu--submenu-item-target').addClass('hidden');

            let index = jQuery(this).data('submenu-index');

            jQuery(this).parent().next().find(`.js-mega-menu--submenu-item-target[data-submenu-index="${index}"]`).removeClass('hidden');
        },
        function () {}
    );

    jQuery('header').hover(
        function () {},
        function () {
            jQuery('.js-mega-menu--toggle').removeClass('active');
            jQuery('header').addClass('mega-menu-opened');
            jQuery('.js-mega-menu--container').hide();
        }
    );
}
